module.exports = __webpack_public_path__ + "img/wave.a67e448f.png";